import { withNamespaces } from "react-i18next";
import { isDsrFlagOn } from "../../../deadline-management/hooks/useDsrDeadlineWorkflow";
import { formatDeadlineDate } from "../../../deadline-management/utils";

const HistoryPeriod = ({ t, period }) => {
  const isActive = isDsrFlagOn(period?.is_active);

  return (
    <div className="dsr-deadline-history__period">
      <div className="d-flex align-items-center gap-2 mb-2">
        <div className="dsr-deadline-card__label mb-0">
          {t("Waiting period started")}
        </div>
        {isActive && (
          <div className="dsr-awaiting-requester-badge">{t("Active")}</div>
        )}
      </div>

      <div className="mb-2">
        <div className="dsr-deadline-card__value">
          {formatDeadlineDate(period?.started_at)}
        </div>
      </div>

      <div className="mb-2">
        <div className="dsr-deadline-card__label">{t("Started by")}</div>
        <div className="dsr-deadline-card__value">{period?.started_by || "—"}</div>
      </div>

      <div className={period?.ended_at ? "mb-3" : ""}>
        <div className="dsr-deadline-card__label">{t("Reason")}</div>
        <div className="dsr-deadline-card__value">{period?.reason || "—"}</div>
      </div>

      {period?.ended_at && (
        <>
          <div className="dsr-deadline-card__label mb-2">
            {t("Waiting period ended")}
          </div>
          <div className="mb-2">
            <div className="dsr-deadline-card__value">
              {formatDeadlineDate(period.ended_at)}
            </div>
          </div>
          <div>
            <div className="dsr-deadline-card__label">{t("Ended by")}</div>
            <div className="dsr-deadline-card__value">{period?.ended_by || "—"}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default withNamespaces()(HistoryPeriod);
